<template>
    <form class="row g-3" id="cat_add" @submit="submitForm($event)" method="post" :action="action">
        <div class="col-md-12">
            <label for="tech_name" class="form-label">Название техники</label>
            <input type="text" v-model="data.title" class="form-control" id="tech_name" required>
        </div>
        <div class="col-md-12">
            <label class="form-label">Категория</label>
            <model-select :options="cat_list"
                          v-model="cat_id"
                          placeholder="Выбрать..."></model-select>

        </div>
        <div class="col-md-12">
            <div class="option_block">
                <h3>Характеристики</h3>
                <button type="button" class="btn btn-success" @click="addSpec()">Добавить</button>
                <div id="tech_spec_list" class="mt-3">

                    <div class="row" v-for="(spec, id) in data.spec">
                        <div class="col-md-4">
                            <label class="form-label">Название параметра</label>
                            <input type="text" v-model="spec.name" value="" class="form-control"
                                   id="tech_param_0" required="">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Значение параметра</label>
                            <input type="text" v-model="spec.value" value="" class="form-control"
                                   required="">
                        </div>
                        <div class="col-md-2 d-flex align-items-end">
                            <button type="button" class="btn btn-danger" @click="deleteSpec(id)">Удалить</button>
                        </div>
                    </div>


                </div>
            </div>
        </div>

        <div class="col-md-12">
            <h3>Цены</h3>
        </div>
        <div class="col-md-4">
            <label for="tech_price" class="form-label">Цена час</label>
            <input type="number" v-model="data.price" @change="calcSmena" class="form-control" id="tech_price" required>
        </div>
        <div class="col-md-4">
            <label for="tech_price_s" class="form-label">Цена смена</label>
            <input type="number" v-model="data.price_s" class="form-control" id="tech_price_s" required>
        </div>
        <div class="col-md-4">
            <label for="tech_discount" class="form-label">Цена со скидкой</label>
            <input type="number" v-model="data.discount" class="form-control" value="0" id="tech_discount" required>
        </div>

        <div class="col-md-2">
            <label for="tech_position" class="form-label">Позиция</label>
            <input type="number" class="form-control" id="tech_position" value="0" v-model="data.position">
        </div>
        <div class="col-md-4">
            <label for="tech_img" class="form-label">Картинка</label>
            <input type="file" class="form-control" id="tech_img" ref="imageInput" @change="uploadImage()"
                   accept="image/*">
        </div>
        <div class="col-md-4">
            <label for="tech_photo" class="form-label">Фото</label>
            <input type="file" class="form-control" id="tech_photo" ref="imagePhoto" @change="uploadPhoto()"
                   accept="image/*">
        </div>
        <div class="col-md-4 d-flex align-items-end">
            <div class="form-check form-switch">
                <input class="form-check-input" v-model="data.enabled" value="1" checked type="checkbox" role="switch"
                       id="tech_active">
                <label class="form-check-label" for="tech_active">Активна</label>
            </div>

        </div>

        <div class="col-12">
            <button type="submit" class="btn btn-primary">Сохранить</button>
        </div>
    </form>
</template>

<script>
    import {ModelSelect} from 'vue-search-select'

    export default {
        components: {
            ModelSelect
        },
        data() {
            return {
                tech: {
                    title: '',
                    cat_id: '',
                    spec: [],

                    price: '',
                    price_s: '',
                    discount: 0,

                    image: '',
                    photo: '',

                    position: 1,
                    enabled: true,
                },
                cat_id: '',
                cat_list: [
                    {
                        text: 'Без категории',
                        value: 0,
                        selected: true
                    }
                ]
            }
        },
        props: ['action', 'data'],
        computed: {
            csrf() {
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
        },
        methods: {
            calcSmena() {
                this.data.price_s = this.data.price * 8;
            },
            addSpec(specName) {

                this.data.spec.push({
                    name: specName ?? '',
                    value: ''
                })
            },
            deleteSpec(id) {
                this.data.spec.splice(id, 1);
            },
            uploadImage() {
                this.data.image = this.$refs.imageInput.files[0];
            },
            uploadPhoto() {
                this.data.photo = this.$refs.imagePhoto.files[0];
            },
            addInput: function () {
                this.data.options.push('');
            },
            deleteInput: function (id) {
                this.data.options.splice(id, 1);
            },
            submitForm: function ($event) {
                const vm = this;
                $event.preventDefault();

                let formData = new FormData();
                const keys = Object.keys(this.data);
                for (let i = 0; i < keys.length; i++) {
                    if (keys[i] === 'spec') {
                        formData.append(keys[i], JSON.stringify(this.data[keys[i]]));
                    } else {
                        formData.append(keys[i], this.data[keys[i]]);
                    }
                }
                formData.append("_method", "put");
                axios.post(this.action, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function (response) {
                    let $data = response.data;
                    if ($data.status === 'success') {
                        vm.$swal({
                            icon: 'success',
                            title: 'Готово!',
                            text: 'Успешно сохранили'
                        });
                        vm.$refs.imageInput.value = null;
                        vm.$refs.imagePhoto.value = null;
                    } else {

                    }

                }).catch(function (error) {
                    let $response = error.response;
                    vm.$swal({
                        icon: 'error',
                        title: 'Ошибка!',
                        text: $response.data.message
                    });
                })
                return false;
            },
            async getAllCat() {
                const vm = this;
                let cat_list;
                return axios.get('/admin/cats/get-all-cat');
            }
        },
        watch: {
            cat_id(newVal, oldVal) {


                if(newVal !== this.data.cat_id && (this.data.cat_id === null ||  this.data.cat_id === ''))
                {
                    const vm = this;
                    this.data.cat_id = newVal;
                    axios.get('/admin/cats/get-cat-spec/' + newVal).then(function (response) {
                        try {
                            let specList = JSON.parse(response.data);
                            if (specList.length) {
                                vm.data.spec = [];
                                for (let i = 0; i < specList.length; i++) {
                                    vm.addSpec(specList[i]);
                                }
                            }
                        } catch (e) {
                            vm.data.spec = [];
                        }
                    })
                }
            }
        },
        mounted() {
            const vm = this;
            this.getAllCat().then(function (response) {
                vm.cat_list = response.data;
            })

            this.data.spec = JSON.parse(this.data.spec);
            this.tech = this.data;
            this.cat_id = this.data.cat_id;

            console.log('Component mounted.')
        }
    }
</script>
